import firebase from "firebase/app";

import Fire from "./Fire";
import { NO_CONN } from "../util/CommonConstants";
import { createRandomId } from "../util/Util";
import { TOKEN_KEY } from "../util/Auth";

var collectionName = "users";
var db;

class UsersColl {
  constructor() {
    db = Fire.shared.getDatabase();
  }

  constructUserId(user) {
    let firstName = user.first_name;
    let firstNameList = user.first_name.split(/\ +/);

    if (firstNameList && firstNameList.length > 1) {
      firstName = firstNameList.join("");
    }

    let lastName = user.last_name;
    let lastNameList = user.last_name.split(/\ +/);

    if (lastNameList && lastNameList.length > 1) {
      lastName = lastNameList.join("");
    }

    return (
      firstName.substring(0, 10) +
      lastName.substring(0, 10) +
      "_" +
      createRandomId()
    );
  }

  async getFirebaseDatabase() {
    if (!Fire.shared.hasBeenInitialized) {
      await Fire.shared.establishFirebase();
    }
    return Fire.shared.getDatabase();
  }

  async getUserByEmail(email) {
    if (!email) {
      return null;
    }

    if (!db) {
      db = await this.getFirebaseDatabase();
    }

    if (!db) {
      return NO_CONN;
    }

    let user = null;
    try {
      let results = await db
        .collection(collectionName)
        .where("email", "==", email)
        .get();

      user = Fire.shared.getSingleDataFromArray(results);
    } catch (err) {
      return false;
    }

    if (user) {
      return user;
    } else {
      return false;
    }
  }

  async getUser(id) {
    if (!id) {
      return null;
    }

    if (!db) {
      db = await this.getFirebaseDatabase();
    }

    if (!db) {
      return NO_CONN;
    }

    let user = null;
    try {
      let results = await db
        .collection(collectionName)
        .where("uid", "==", id)
        .get();

      user = Fire.shared.getSingleDataFromArray(results);
    } catch (err) {
      console.log(err);
      return false;
    }

    if (user) {
      return user;
    } else {
      console.log("No user found!");
      return false;
    }
  }

  async getUserById(id) {
    if (!id) {
      return null;
    }

    if (!db) {
      db = await this.getFirebaseDatabase();
    }

    if (!db) {
      return null;
    }

    let user = null;
    try {
      user = await Fire.shared.getSingleDocumentById(id, collectionName);
    } catch (err) {
      console.log("Failed to get user!");
      console.log(err);
      return null;
    }

    if (user) {
      return user;
    } else {
      console.log("No user found: ", user);
      return null;
    }
  }

  async getUserEmail(id) {
    if (!id) {
      return null;
    }

    if (!db) {
      db = await this.getFirebaseDatabase();
    }

    if (!db) {
      return false;
    }

    let user = null;
    try {
      user = await Fire.shared.getSingleDocumentById(id, collectionName);
    } catch (err) {
      return false;
    }

    if (user) {
      return user.email;
    } else {
      return false;
    }
  }

  async getAllUsers(organization_id = null) {
    if (!db) {
      db = await this.getFirebaseDatabase();
    }

    if (!db) {
      return [];
    }

    let users = [];
    try {
      let results = await db.collection(collectionName).get();

      users = Fire.shared.getDataArray(results);

      if (organization_id) {
        users = users.filter(
          (user) =>
            user.organizations && user.organizations.includes(organization_id)
        );
      }
    } catch (err) {
      console.log("Failed to get all users: ", err);
      return [];
    }

    return users;
  }

  async updateUserOrganizations(id, orgs) {
    if (!id || !orgs) {
      return null;
    }

    if (!db) {
      db = await this.getFirebaseDatabase();
    }

    if (!db) {
      return NO_CONN;
    }

    try {
      await db.collection(collectionName).doc(id).update({
        organizations: orgs
      });
    } catch (err) {
      console.log(err);
      return false;
    }
  }

  async createUser(user) {
    user.id = this.constructUserId(user);

    var response = await Fire.shared.createSingleDocumentById(
      user,
      collectionName
    );

    if (typeof response === "string" || response instanceof String) {
      return false;
    }

    if (response === true) {
      localStorage.setItem(TOKEN_KEY, JSON.stringify(user));
      return true;
    } else {
      return false;
    }
  }

  async registerAndCreateUser(user, password) {
    if (!user || !user.email || !password) {
      return false;
    }

    let currentUser = null;
    try {
      let authUser = await firebase
        .auth()
        .createUserWithEmailAndPassword(user.email, password);
      if (authUser.user && authUser.user.uid) {
        user.uid = authUser.user.uid;
        currentUser = authUser.user;

        // Send verification email
        await currentUser.sendEmailVerification();
      } else {
        return false;
      }
    } catch (error) {
      console.log("Failed to create user: ", error);
      if (error.message) {
        alert(error.message);
      }
      return false;
    }

    var userData = await this.createUser(user);
    if (userData === true) {
      return true;
    } else {
      //delete current user auth
      try {
        await currentUser.delete();
      } catch (error) {
        console.log("Failed to delete user auth: ", error);
      }
      return false;
    }
  }
}

UsersColl.shared = new UsersColl();

export default UsersColl;
